import React from 'react';

import { PRODUCT_TYPE } from 'constants/product';
import { useQueryParameters } from 'hooks/url/useQueryParameters';
import PortalHeader from 'components/header/PortalHeader';
import ProductMatch from 'components/product/ProductMatch';
import ProductSwitch from 'components/product/ProductSwitch';
import SourcingHeader from 'components/header/SourcingHeader';

//

const Header = props => {
  const { isMinimized } = props;

  const { portalId, productType } = useQueryParameters();

  return (
    <ProductSwitch currentProduct={productType}>
      <ProductMatch product={PRODUCT_TYPE.CONTRACT}>Contract Header</ProductMatch>
      <ProductMatch product={PRODUCT_TYPE.PORTAL}>
        <PortalHeader isMinimized={isMinimized} portalId={portalId} />
      </ProductMatch>
      <ProductMatch product={PRODUCT_TYPE.SOURCING}>
        <SourcingHeader isMinimized={isMinimized} />
      </ProductMatch>
    </ProductSwitch>
  );
};

export default React.memo(Header);
